import React, { PureComponent } from 'react'
import {
    // @ts-ignore
    ShimmeredDetailsList, SelectionMode, DetailsListLayoutMode, ConstrainMode, Text, IColumn,
} from '@fluentui/react'
import { onColumnClick } from 'helpers/methods/common'
import Status from 'types/status'
// @ts-ignore
// eslint-disable-next-line import/named
import { AppProps } from 'app'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import flattenObj from 'helpers/methods/flattenObj'
import Card from 'components/containers/card'
import styles from 'styles/pages/lastExports.module.scss'
import Export from 'requests/objects/export'
import Time from 'helpers/methods/time'
import { Link } from 'react-router-dom'
import Pagination from 'components/pages/Pagination'

/** @debug {AppProps} */

/**
 * @augments {PureComponent<AppProps>} extends
 */
export default class LastExports extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {Export[]} Items found in API */
            items: [],
            /** @type {import('components/pages/Pagination').PagingationType} pagination data */
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalRecords: 0,
            },
        }
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.init()

        // this.search()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     * @param {object} prevState Previous State
     */
    // @ts-ignore
    componentDidUpdate(prevProps, prevState) {
        const { pagination: { currentPage } } = this.state

        if (prevState?.pagination?.currentPage && prevState.pagination.currentPage !== currentPage)
            this.search()

        // this.init()

        // this.setupBreadcrumb()

        // this.setupCommandBar()

        // this.setState({
        //     columns: this.buildColumns(),
        // })
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.exportsHandlerGetAll?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb } = this.props

        setBreadcrumb([
            { text: 'Derniers exports', key: 'export', isCurrentItem: true },
        ])
    }

    /**
     * Init Page
     */
    init() {
        const { setMessageBar, setCommand } = this.props

        setMessageBar({ isDisplayed: false })
        setCommand([])

        this.setupBreadcrumb()

        this.setState({ columns: this.buildColumns() }, () => this.search())
    }

    /**
     * Init <DetailList>
     * @returns {IColumn[]} Columns
     */
    // eslint-disable-next-line class-methods-use-this
    buildColumns() {
        return [
            {
                key: 'id',
                name: 'Id',
                fieldName: 'exportId',
                minWidth: 50,
                maxWidth: 100,
                isResizable: true,
            },
            {
                key: 'createdAt',
                name: 'Exporté le',
                fieldName: 'createdAt',
                minWidth: 130,
                maxWidth: 200,
                isResizable: true,
                onRender: item => this.renderDate(item.createdAt),
            },
            {
                key: 'rubricExportId',
                name: 'Export des rubriques',
                fieldName: 'rubricExportId',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: item => this.renderStatus(item.rubricExportId),
            },
            {
                key: 'timeExportId',
                name: 'Export de temps',
                fieldName: 'timeExportId',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: item => this.renderStatus(item.timeExportId),
            },
            {
                key: 'createdById',
                name: 'Créé par',
                fieldName: 'createdBy.name',
                minWidth: 130,
                maxWidth: 250,
                isResizable: true,
            },
        ]
    }

    /**
     * Search elements
     */
    search() {
        this.setState({
            status: Status.PENDING,
        }, async () => {
            const { exportHandler, match } = this.props
            const { pagination: { currentPage } } = this.state

            try {
                this.exportsHandlerGetAll?.cancel()
                this.exportsHandlerGetAll = exportHandler.getAllFromPage({
                    page: match.params?.key,
                    currentPage,
                })
                const res = await this.exportsHandlerGetAll.fetch()
                this.setState({
                    items: res.items.map(x => this.flattenObj(x)),
                    pagination: {
                        currentPage: res.items.length === 0 ? 1 : currentPage,
                        totalPages: res.totalPages,
                        totalRecords: res.totalRecords,
                    },
                    status: Status.RESOLVED,
                })
            } catch (error) {
                switch (error?.constructor) {
                    case CancelRequestError:
                    case UnauthorizedError:
                    case InvalidEntityError: break
                    case NotImplementedError:
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                    default:
                        this.setState({
                            items: [],
                            status: Status.REJECTED,
                        })
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                }
            }
        })
    }

    /**
     * @param {number} exportStatusId exportStatusId
     * @returns {JSX.Element} Element
     */
    renderStatus(exportStatusId) {
        const { param } = this.props

        if (!exportStatusId)
            return (<div />)

        return (<Text>{param.exportStatuses.find(x => x.key === exportStatusId).text}</Text>)
    }

    /**
     * @param {Date} date date
     * @returns {JSX.Element} Element
     */
    // eslint-disable-next-line class-methods-use-this
    renderDate(date) {
        return (
            <Text>
                {Time(date).getCleanDate({
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                })}
            </Text>
        )
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            columns, status, items, pagination,
        } = this.state

        return (
            <main className={styles.index}>
                <Card>
                    <ShimmeredDetailsList
                        items={items}
                        detailsListStyles={{
                            root: {
                                selectors: {
                                    '& [role=grid]': {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'start',
                                        height: items.length ? '65vh' : 'auto',
                                    },
                                },
                            },
                            headerWrapper: {
                                flex: '0 0 auto',
                            },
                            contentWrapper: {
                                flex: '1 1 auto',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                            },
                        }}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        onShouldVirtualize={() => true}
                        enableShimmer={status === Status.PENDING}
                        layoutMode={DetailsListLayoutMode.justified}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={(props, defaultRender) => defaultRender({ ...props, styles: { root: { paddingTop: 0 } } })}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        onRenderRow={(props, defaultRender) => (
                            <Link
                                to={{
                                    pathname: `/exports/${props.item?.exportId}`,
                                }}
                            >
                                {defaultRender(props)}
                            </Link>
                        )}
                    />
                    {!items?.length && [Status.RESOLVED, Status.REJECTED].includes(status)
                        && <Text styles={{ root: { fontStyle: 'italic', marginLeft: '1em' } }}>Aucun résultat trouvé</Text>}
                </Card>
                <Pagination
                    data={pagination}
                    dataName="Export"
                    onPageChange={page => this.setState({ pagination: { ...pagination, currentPage: page } })}
                />
            </main>
        )
    }
}

LastExports.prototype.onColumnClick = onColumnClick
LastExports.prototype.flattenObj = flattenObj
